function isPhone(userAgent) {
  const phoneKeywords = [
    'Android', 'iPhone', 'Mobile', 'iPod', 'BlackBerry',
    'Opera Mini', 'IEMobile', 'Windows Phone', 'webOS',
  ];
  return phoneKeywords.some((keyword) => userAgent.includes(keyword));
}

const phone = isPhone(navigator.userAgent);

export default {
  phone,
};
